import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import * as keyboardEventHelpers from 'globals/keyboardEvents';
import { injectIntl, intlShape } from 'react-intl';

import styles from './styles';
import messages from './messages';
import ChatHistoryHeaderInfo from '../ChatHistoryHeaderInfo';

export const ChatHistoryHeader = ({ onClose, intl }) => {
  const handleKeyPress = e => {
    if (keyboardEventHelpers.isEnterKey(e)) {
      e.preventDefault();
      e.stopPropagation();

      onClose();
    }
  };
  return (
    <div
      key="wrapper"
      style={styles.wrapper}
      className="kustomer-app-header"
      role="main"
      aria-label={intl.formatMessage(messages.aria_label_main)}
    >
      <ChatHistoryHeaderInfo />
      <div
        style={styles.close.wrapper}
        className="iconButton closeButton kustomer-app-header-close-button"
        onClick={onClose}
        onKeyPress={handleKeyPress}
        tabIndex="0"
        role="button"
        aria-label={intl.formatMessage(messages.aria_label_close_button)}
      >
        <div style={styles.close.icon} />
      </div>
    </div>
  );
};

ChatHistoryHeader.propTypes = {
  onClose: PropTypes.func,
  intl: intlShape.isRequired,
};

ChatHistoryHeader.defaultProps = {
  onClose: () => {},
};

export const componentWithIntl = injectIntl(ChatHistoryHeader);
export default Radium(componentWithIntl);
